import { Spin } from 'antd';
import { ReactNode } from 'react';
import './SpinComponent.css';

type AllProps = {
  isLoading: boolean;
  title?: string;
  children: ReactNode;
};

function SpinComponent({ isLoading, title, children }: AllProps) {
  return (
    <div className="spin-component">
      {isLoading ? (
        <div className="spin-block">
          <Spin size="large" />
          {title && <div className="spin-title">{title}</div>}
        </div>
      ) : (
        children
      )}
    </div>
  );
}

export default SpinComponent;
